.flag {
  display: inline-flex;
  margin-left: 1rem;
}

/* The icon carries the score colour; the label stays in text colour for contrast. */
.flag {
  color: var(--color-text);
}

.success svg {
  color: var(--color-positive);
}

.failure svg {
  color: var(--color-negative);
}
